import { addMonths, format, parse, startOfMonth, subMonths } from 'date-fns';
import {
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import {
  ShortLeftArrowIcon,
  ShortRightArrowIcon,
} from '../../services/SvgLibrary';
import styles from '../../styles/calendar/Calendar.module.scss';
import { generateSafeDateFromMonthYear } from '../../utils/helper';
import { CalendarContext } from './CalendarContext';

const CalendarHeader = ({
  children,
  isLoading,
  sortByDateNeeded,
  getRequestCurrentMonthAndYear,
}) => {
  const {
    currentMonth,
    years,
    months,
    setCurrentMonth,
    onSelectTime,
    storageKey,
  } = useContext(CalendarContext);

  const [inputYear, setInputYear] = useState(null);
  const [inputMonth, setInputMonth] = useState(1);
  const [selectingMMYY, setSelectingMMYY] = useState(false);
  const parsedDate = parse(currentMonth, 'MMM yyyy', new Date());
  const monthName = format(parsedDate, 'MMMM');
  const yearStr = format(parsedDate, 'yyyy');

  useEffect(() => {
    const validTime = generateSafeDateFromMonthYear(currentMonth);
    let monthIndex = Number(format(new Date(validTime), 'M')) - 1
    setInputMonth( String(monthIndex) )
    setInputYear(format(new Date(validTime), 'yyyy'));
  }, []);

  const updateCalendar = (action = 'today') => {
    let newCurrentMonth;

    switch (action) {
      case 'previous':
        newCurrentMonth = subMonths(startOfMonth(parsedDate), 1);
        break;
      case 'next':
        newCurrentMonth = addMonths(startOfMonth(parsedDate), 1);
        break;
      default:
        newCurrentMonth = new Date();
        break;
    }

    getRequestCurrentMonthAndYear(
      newCurrentMonth.getMonth() + 1,
      newCurrentMonth.getFullYear(),
      sortByDateNeeded ?? sortByDateNeeded
    );

    const formattedNext = format(newCurrentMonth, 'MMM yyyy');
    localStorage.setItem(storageKey, formattedNext);
    setCurrentMonth(formattedNext);
    setInputMonth(newCurrentMonth.getMonth());
    setInputYear(newCurrentMonth.getFullYear());
  };

  const SelectMonthYear = () => {
    return (
      <div className={styles['change-monthYear-container']}>
        <select
          className={styles['select-box']}
          value={inputMonth}
          onChange={e => {
            setInputMonth(Number(e.target.value));
          }}>
          {months.map((m, idx) => (
            <option value={idx} key={idx}>
              {m}
            </option>
          ))}
        </select>
        <select
          className={styles['select-box']}
          value={inputYear}
          onChange={e => {
            setInputYear(Number(e.target.value));
          }}>
          {years.map((y, idx) => (
            <option value={y} key={idx}>
              {y}
            </option>
          ))}
        </select>
        <button
          className={styles.submit}
          onClick={e => {
            setSelectingMMYY(false);
            onSelectTime(
              e,
              getRequestCurrentMonthAndYear,
              inputMonth,
              inputYear
            );
          }}>
          GO
        </button>
        <button
          className={`btn ${styles['close-monthYear-input-fields']}`}
          onClick={() => setSelectingMMYY(false)}>
          Cancel
        </button>
      </div>
    );
  };
  const CurrentMonthYear = () => {
    return (
      <div className='d-flex align-items-center'>
        <button
          disabled={isLoading}
          className={`btn ${styles['calendar-view-toggle']}`}
          onClick={() => updateCalendar('today')}>
          Today
        </button>
        <ShortLeftArrowIcon
          classNameProp={`${styles['arrow-month-selection']} ${
            isLoading ? styles['disabled'] : ''
          }`}
          onClickFunction={() => {
            if (!isLoading) updateCalendar('previous');
          }}
        />
        <ShortRightArrowIcon
          classNameProp={`${styles['arrow-month-selection']} ${
            isLoading ? styles['disabled'] : ''
          }`}
          onClickFunction={() => {
            if (!isLoading) updateCalendar('next');
          }}
        />
        <div
          className={`ms-1 d-flex align-items-center ${styles['current-month-container']}`}
          onClick={() => setSelectingMMYY(true)}>
          <span className={styles['current-month-wrapper']}>{monthName}</span>
          &nbsp;
          <span className={styles['current-year-wrapper']}>{yearStr}</span>
        </div>
      </div>
    );
  };
  return (
    <div className={styles['calendarHeader']}>
      {/* Left side: Navigation */}
      {selectingMMYY ? <SelectMonthYear /> : <CurrentMonthYear />}

      {/* Right side: Filters & New button OR render children if provided */}
      <div className={styles['header-right-side']}>
        {isLoading && (
          <div className={styles['fixed-loading-container-header']}>
            <img
              src='/img/newLoadingAnimation.gif'
              alt='Loading animation'
              className='loading-image'
            />
          </div>
        )}
        {children ?? null}
      </div>
    </div>
  );
};

export default CalendarHeader;
